var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.818,
    height: 30,
    viewBox: "0 0 27.818 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CONTACT",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2883",
    "data-name": "Rectangle 2883",
    transform: "translate(0.454)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.363,
    height: 30,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24.363,
    height: 28,
    rx: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_45",
    "data-name": "Ligne 45",
    x2: 5.454,
    transform: "translate(0 7.088)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_46",
    "data-name": "Ligne 46",
    x2: 5.454,
    transform: "translate(0 22.612)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_47",
    "data-name": "Ligne 47",
    x2: 5.454,
    transform: "translate(0 14.85)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.f3e05cad51c11715868afc7959872ce7.svg";
export { ForwardRef as ReactComponent };